import { render, staticRenderFns } from "./OccupationSelect.vue?vue&type=template&id=24842c6e&"
import script from "./OccupationSelect.vue?vue&type=script&lang=js&"
export * from "./OccupationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports